import { Box, Button, SxProps, Typography, useTheme } from '@mui/material';

import { PortalTheme } from '../../theme';

export interface MenuLinkProps {
  title: string | undefined;
  description: string | undefined;
  onClick: () => void;
  sx?: SxProps;
}

export const MenuLink = (props: MenuLinkProps) => {
  const theme = useTheme<PortalTheme>();

  return (
    <Button
      color="primary"
      variant="contained"
      sx={{
        justifyContent: 'start',
        textTransform: 'none',
        borderRadius: `${theme.shape.borderRadius}px`,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.boxShadow,
        ...props.sx,
      }}
      onClick={props.onClick}
    >
      <Box
        flexDirection="column"
        sx={{ display: 'flex', flexGrow: 1, alignItems: 'start' }}
      >
        <Typography component="span">{props.title}</Typography>
        <Typography
          component="span"
          color={theme.palette.text.primaryAlternativeContrast}
        >
          {props.description}
        </Typography>
      </Box>
    </Button>
  );
};
